import ViewListaKonfiguracji from "../../components/views/app/konfiguracja/oper/ViewListaKonfiguracji.jsx"
import ViewEdycjaPozycjiKonfiguracji from "../../components/views/app/konfiguracja/oper/ViewEdycjaPozycjiKonfiguracji.jsx"

export const konfiguracjaRoutes = [

    {
        path: '/oper/konfiguracja/lista',
        exact: true,
        roles: ['konfiguracja_podglad'],
        forbidden: true,
        view: <ViewListaKonfiguracji/>,
        mode: 'any'
    },
    {
        path: '/oper/konfiguracja/:tryb/:id',
        exact: true,
        roles: ['konfiguracja_modyfikacja'],
        forbidden: true,
        view: <ViewEdycjaPozycjiKonfiguracji/>,
        mode: 'any'
    },
]